// extracted by mini-css-extract-plugin
module.exports = {"spotKbygRewinds":"SpotKbygRewinds_spotKbygRewinds__i0iNi"};